import { render, staticRenderFns } from "./InvoiceProductsForm.vue?vue&type=template&id=c51c5282"
import script from "./InvoiceProductsForm.vue?vue&type=script&lang=js"
export * from "./InvoiceProductsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports